import {RouteObject} from 'react-router';
import {authGuard} from '@common/auth/guards/auth-route';

const lazyRoute = async (
  cmp: keyof typeof import('@app/routes/site-routes.lazy'),
) => {
  const exports = await import('@app/routes/site-routes.lazy');
  return {
    Component: exports[cmp],
  };
};

export const siteRoutes: RouteObject[] = [
  {
    loader: () => authGuard({permission: 'titles.view', requireLogin: false}),
    children: [
      {
        index: true,
        lazy: () => lazyRoute('Homepage'),
      },
        // AFLM localized homepages
        {
          path: 'ar',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'fr',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'de',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'es',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'it',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'pt',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'tr',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'ru',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'pl',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'nl',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'sv',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'da',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'fi',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'cs',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'el',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'he',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'fa',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'ur',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'hi',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'bn',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'id',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'th',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'vi',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'ja',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'ko',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'zh',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'uk',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'ro',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'hu',
          lazy: () => lazyRoute('Homepage'),
        },
        {
          path: 'bg',
          lazy: () => lazyRoute('Homepage'),
        },

      {
        path: 'landing',
        lazy: () => lazyRoute('LandingPage'),
      },
      {
        path: 'search',
        lazy: () => lazyRoute('SearchPage'),
      },
      {
        path: 'search/:query',
        lazy: () => lazyRoute('SearchPage'),
      },
      // AFLM localized search routes
      {
        path: ':locale/search',
        lazy: () => lazyRoute('SearchPage'),
      },
      {
        path: ':locale/search/:query',
        lazy: () => lazyRoute('SearchPage'),
      },

      // Watch
      {
        path: 'watch/:videoId',
        lazy: () => lazyRoute('WatchPage'),
      },
      // AFLM localized title routes
      {
        path: ':locale/titles/:titleId/:titleSlug',
        lazy: () => lazyRoute('TitlePage'),
      },
      {
        path: ':locale/titles/:titleId/:titleSlug/videos',
        lazy: () => lazyRoute('TitleVideosPage'),
      },
      {
        path: ':locale/titles/:titleId/:titleSlug/images',
        lazy: () => lazyRoute('TitleImagesPage'),
      },
      {
        path: ':locale/titles/:titleId/:titleSlug/full-credits',
        lazy: () => lazyRoute('TitleFullCreditsPage'),
      },

      // AFLM localized season / episode routes
      {
        path: ':locale/titles/:titleId/:titleSlug/season/:season',
        lazy: () => lazyRoute('SeasonPage'),
      },
      {
        path: ':locale/titles/:titleId/:titleSlug/season/:season/episode/:episode',
        lazy: () => lazyRoute('EpisodePage'),
      },
      {
        path: ':locale/titles/:titleId/:titleSlug/season/:season/episode/:episode/full-credits',
        lazy: () => lazyRoute('EpisodeFullCreditsPage'),
      },
      {
        path: ':locale/titles/:titleId/:titleSlug/season/:season/episode/:episode/videos',
        lazy: () => lazyRoute('EpisodeVideosPage'),
      },

      // Titles
      {
        path: 'titles/:titleId/:titleSlug',
        lazy: () => lazyRoute('TitlePage'),
      },
      {
        path: 'titles/:titleId/:titleSlug/videos',
        lazy: () => lazyRoute('TitleVideosPage'),
      },
      {
        path: 'titles/:titleId/:titleSlug/images',
        lazy: () => lazyRoute('TitleImagesPage'),
      },
      {
        path: 'titles/:titleId/:titleSlug/full-credits',
        lazy: () => lazyRoute('TitleFullCreditsPage'),
      },
      {
        path: 'titles/:titleId/:titleSlug/season/:season',
        lazy: () => lazyRoute('SeasonPage'),
      },
      {
        path: 'titles/:titleId/:titleSlug/season/:season/episode/:episode',
        lazy: () => lazyRoute('EpisodePage'),
      },
      {
        path: 'titles/:titleId/:titleSlug/season/:season/episode/:episode/full-credits',
        lazy: () => lazyRoute('EpisodeFullCreditsPage'),
      },
      {
        path: 'titles/:titleId/:titleSlug/season/:season/episode/:episode/videos',
        lazy: () => lazyRoute('EpisodeVideosPage'),
      },
      // People
      {
        path: ':locale/people/:personId',
        lazy: () => lazyRoute('PersonPage'),
      },
      {
        path: ':locale/people/:personId/:personSlug',
        lazy: () => lazyRoute('PersonPage'),
      },
      {
        path: 'people/:personId',
        lazy: () => lazyRoute('PersonPage'),
      },
      {
        path: 'people/:personId/:personSlug',
        lazy: () => lazyRoute('PersonPage'),
      },
      // News
      {
        path: 'news/:articleId',
        lazy: () => lazyRoute('NewsArticlePage'),
      },
      // Profile page
      {
        path: 'user/:userId/:slug',
        lazy: () => lazyRoute('UserProfilePage'),
        children: [
          {
            index: true,
            lazy: () => lazyRoute('ProfileListsPanel'),
          },
          {
            path: 'lists',
            lazy: () => lazyRoute('ProfileListsPanel'),
          },
          {
            path: 'ratings',
            lazy: () => lazyRoute('ProfileRatingsPanel'),
          },
          {
            path: 'reviews',
            lazy: () => lazyRoute('ProfileReviewsPanel'),
          },
          {
            path: 'comments',
            lazy: () => lazyRoute('ProfileCommentsPanel'),
          },
          {
            path: 'followers',
            lazy: () => lazyRoute('ProfileFollowersPanel'),
          },
          {
            path: 'followed-users',
            lazy: () => lazyRoute('ProfileFollowedUsersPanel'),
          },
        ],
      },
      {
        path: 'user/:userId/:slug/:tab',
        lazy: () => lazyRoute('UserProfilePage'),
      },
      // User Lists
      {
        path: 'lists',
        loader: () => authGuard(),
        lazy: () => lazyRoute('UserListsIndexPage'),
      },
      {
        path: 'lists/new',
        loader: () => authGuard(),
        lazy: () => lazyRoute('SiteCreateUserListPage'),
      },
      {
        path: 'lists/:slugOrId',
        lazy: () => lazyRoute('ListChannelPage'),
      },
      {
        path: 'lists/:slugOrId/edit',
        loader: () => authGuard(),
        lazy: () => lazyRoute('SiteEditUserListPage'),
      },

      // Channels
      {
        path: ':slugOrId',
        lazy: () => lazyRoute('ChannelPage'),
      },
      {
        path: 'channel/:slugOrId',
        lazy: () => lazyRoute('ChannelPage'),
      },
      {
        path: ':slugOrId/:restriction',
        lazy: () => lazyRoute('ChannelPage'),
      },
      
        {
          path: ':locale/:slugOrId/:restriction',
          lazy: () => lazyRoute('ChannelPage'),
        },
{
        path: 'channel/:slugOrId/:restriction',
        lazy: () => lazyRoute('ChannelPage'),
      },
    ],
  },
];
